/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";
import {
  PluginAssignment,
  PluginAssignment$inboundSchema,
} from "./pluginassignment.js";
import { PluginServer, PluginServer$inboundSchema } from "./pluginserver.js";

export type Plugin = {
  /**
   * Whether the plugin's complete current intended state can be published as an Agent Plugins 1.0 package.
   */
  agentPluginsV1Compatible: boolean;
  /**
   * Number of role/user assignments.
   */
  assignmentCount?: number | undefined;
  /**
   * Role/user assignments.
   */
  assignments?: Array<PluginAssignment> | undefined;
  /**
   * Whether automatic role distribution created this plugin. Read-only; preserved after edits and reuse.
   */
  autoCreated: boolean;
  createdAt: Date;
  /**
   * Optional description.
   */
  description?: string | undefined;
  /**
   * Unique plugin identifier.
   */
  id: string;
  /**
   * Whether this is the project's fallback plugin that new servers attach to.
   */
  isDefault?: boolean | undefined;
  /**
   * Display name.
   */
  name: string;
  /**
   * Number of active servers in this plugin.
   */
  serverCount?: number | undefined;
  /**
   * Servers included in this plugin.
   */
  servers?: Array<PluginServer> | undefined;
  /**
   * Number of active skills in this plugin.
   */
  skillCount?: number | undefined;
  /**
   * URL-safe identifier, unique per org.
   */
  slug: string;
  updatedAt: Date;
};

/** @internal */
export const Plugin$inboundSchema: z.ZodMiniType<Plugin, unknown> = z.pipe(
  z.object({
    agent_plugins_v1_compatible: z.boolean(),
    assignment_count: z.optional(z.int()),
    assignments: z.optional(z.array(PluginAssignment$inboundSchema)),
    auto_created: z.boolean(),
    created_at: z.pipe(
      z.iso.datetime({ offset: true }),
      z.transform(v => new Date(v)),
    ),
    description: z.optional(z.string()),
    id: z.string(),
    is_default: z.optional(z.boolean()),
    name: z.string(),
    server_count: z.optional(z.int()),
    servers: z.optional(z.array(PluginServer$inboundSchema)),
    skill_count: z.optional(z.int()),
    slug: z.string(),
    updated_at: z.pipe(
      z.iso.datetime({ offset: true }),
      z.transform(v => new Date(v)),
    ),
  }),
  z.transform((v) => {
    return remap$(v, {
      "agent_plugins_v1_compatible": "agentPluginsV1Compatible",
      "assignment_count": "assignmentCount",
      "auto_created": "autoCreated",
      "created_at": "createdAt",
      "is_default": "isDefault",
      "server_count": "serverCount",
      "skill_count": "skillCount",
      "updated_at": "updatedAt",
    });
  }),
);

export function pluginFromJSON(
  jsonString: string,
): SafeParseResult<Plugin, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => Plugin$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'Plugin' from JSON`,
  );
}
